window.PartnerInformation = (function ($, validation) {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            buttons: {
                cancelButton: '#partner-information-form-button1',
                continueButton: '#partner-information-form-button2'
            },
            messages:{
                invalidFormMessage: '#partner-information-form-invalid-form-message'
            },
            dropdown:{
                selectedTitle: '#partner-information-form-title option:selected',
                title: '#partner-information-form-title'
            },
            textBox:{
                section: '#partner-information-form-section',
                firstname: '#partner-information-form-firstname',
                surname: '#partner-information-form-surname',
                day: '#partner-information-form-day',
                month: '#partner-information-form-month',
                year: '#partner-information-form-year',
            },
            radioButton:{
                selectedGenderAtBirth: 'input[name="gender-at-birth"]:checked',
                radiobutton1: '#partner-information-form-radiobutton1',
                radiobutton2: '#partner-information-form-radiobutton2'
            }
        },
        css:{
            invalidTextBoxError : 'vds-form__input--invalid',
            radioGroup: '.vds-form__radios--contained',
            invalidRadioButtonError : 'vds-form__radios--error',
        },
        urls: {
            errorPageUrl: '/error/error-page',
            manageMembers: '/my-health-insurance/manage-my-plan/manage-members',
            resetSession: '/api/sitecore/AddMembers/ResetSession',
            cachePartnerDetails: '/api/sitecore/AddMembers/CachePartnerDetails',
            reviewDetails: '/my-health-insurance/manage-my-plan/add-members/review-details',
            dependentCount: '/my-health-insurance/manage-my-plan/add-members/dependent-count'
        },
        statusDescription: {
            ok: 'OK',
            badRequest: 'BadRequest'
        },
        func: {
            init: function () {
                self.func.bindings();
                $('body').on('submit', '#partner-information-form', function (event) {
                    self.func.savePartnerDetailsRequest(event);
                });
            },
            bindings: function () {
                $(self.elements.buttons.cancelButton).on('click', self.func.cancelPartnerDetailsRequest);
            },
            cancelPartnerDetailsRequest: function (event) {
                event.preventDefault();
                // AJAX call to reset the session.
                $.post(self.urls.resetSession)
                    .done(function () {
                        window.location.href = self.urls.manageMembers;
                    })
                    .fail(function () {
                        window.location.href = self.urls.errorPageUrl;
                    });
            },
            savePartnerDetailsRequest: function (event) {
                event.preventDefault();
                const formData = self.func.gatherFormData();
                self.func.sendFormData(formData);
            },
            gatherFormData: function () {
                const dayDigits = 2;
                const monthDigits = 2;
                const yearDigits = 4;
                const guid = $(self.elements.textBox.section).attr('data-dep-guid');
                const title = $(self.elements.dropdown.selectedTitle).val().trim();
                const firstName = $(self.elements.textBox.firstname).val().trim();
                const surname = $(self.elements.textBox.surname).val().trim();
                const day = $(self.elements.textBox.day).val().trim().padStart(dayDigits, '0');
                const month = $(self.elements.textBox.month).val().trim().padStart(monthDigits, '0');
                const year = $(self.elements.textBox.year).val().trim().padStart(yearDigits, '0');
                const genderAtBirth = $(self.elements.radioButton.selectedGenderAtBirth).val();
                return {
                    guid: guid,
                    title: title,
                    firstName: firstName,
                    lastName: surname,
                    dateOfBirth: `${year}-${month}-${day}`,
                    genderAtBirth: genderAtBirth
                };
            },
            sendFormData: function (formData) {
                $.ajax({
                    url: self.urls.cachePartnerDetails,
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(formData),
                    success: function (response) {
                        if (response.statusCode === self.statusDescription.ok) {
                            const previousPageUrl = document.referrer;
                            if (previousPageUrl && previousPageUrl.includes('/review-details')) {
                                window.location.href = self.urls.reviewDetails;
                            }
                            else {
                                window.location.href = response.isAddChildrenDetails ?
                                    self.urls.dependentCount : self.urls.reviewDetails;
                            }
                        } else if (response.statusCode === self.statusDescription.badRequest) {
                            validation.setCustomErrors(response.errors);
                        } else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    },
                    error: function () {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            }
        }
    };

    return {
        Init: self.func.init
    };
})(window.jQuery, window.Validation);

$(document).ready(function () {
    if ('partnerInformation' === $('#partner-information-form').data('feature')) {
        window.PartnerInformation.Init();
    }
});
